import { Color, Flex, Icon } from '@billy/design-system'
import { format } from 'date-fns'
import { ReactDatePickerProps } from 'react-datepicker'

import { useLocale } from '../../hooks/useLocale'
import * as Styled from './styles'

export type CalendarHeaderComponent = ReactDatePickerProps['renderCustomHeader']

const CalendarHeader: CalendarHeaderComponent = ({
  decreaseMonth,
  decreaseYear,
  increaseMonth,
  increaseYear,
  nextMonthButtonDisabled,
  prevYearButtonDisabled,
  nextYearButtonDisabled,
  prevMonthButtonDisabled,
  date,
}) => {
  const locale = useLocale()
  const month = format(date, 'MMMM', { locale })
  const year = format(date, 'yyyy', { locale })
  return (
    <Flex>
      <Styled.MonthHeader>
        <Icon
          icon="chevronLeft"
          onClick={decreaseMonth}
          color={prevMonthButtonDisabled ? Color.Grey100 : 'currentColor'}
        />
        {month}
        <Icon
          icon="chevronRight"
          onClick={increaseMonth}
          color={nextMonthButtonDisabled ? Color.Grey100 : 'currentColor'}
        />
      </Styled.MonthHeader>

      <Styled.CalendarHeaderContainer>
        <Icon
          icon="chevronLeft"
          onClick={decreaseYear}
          color={prevYearButtonDisabled ? Color.Grey100 : 'currentColor'}
        />
        {year}
        <Icon
          icon="chevronRight"
          onClick={increaseYear}
          color={nextYearButtonDisabled ? Color.Grey100 : 'currentColor'}
        />
      </Styled.CalendarHeaderContainer>
    </Flex>
  )
}

export default CalendarHeader
